module.exports = __webpack_public_path__ + "img/malaysia.b977463a.svg";